import { createContext, useContext, useEffect, useState } from 'react';

const CartContext = createContext(null);
const STORAGE_KEY = 'lint-cart';

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  // item: { kind: 'product'|'combo', id, name, name_en, price, category }
  const add = (item, qty = 1) => {
    setItems((prev) => {
      const i = prev.findIndex((x) => x.kind === item.kind && x.id === item.id);
      if (i >= 0) {
        const next = [...prev];
        next[i] = { ...next[i], qty: next[i].qty + qty };
        return next;
      }
      return [...prev, { ...item, qty }];
    });
  };

  const setQty = (kind, id, qty) => {
    setItems((prev) =>
      qty <= 0
        ? prev.filter((x) => !(x.kind === kind && x.id === id))
        : prev.map((x) => (x.kind === kind && x.id === id ? { ...x, qty } : x))
    );
  };

  const remove = (kind, id) => setItems((prev) => prev.filter((x) => !(x.kind === kind && x.id === id)));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, x) => s + x.price * x.qty, 0);
  const count = items.reduce((s, x) => s + x.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
